import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import moment from 'moment';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { CompensatoryOffService } from '../../../Model/CompensatoryOff/compensatory-off.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterOutlet, RouterModule } from '@angular/router';
import { NgbDatepickerModule, NgbDropdownModule, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-compensatory-off-consume',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, NgbDatepickerModule, FormsModule, JsonPipe, DataTablesModule, NgbDropdownModule, LoaderComponent],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './compensatory-off-consume.component.html',
  styleUrl: './compensatory-off-consume.component.scss'
})
export class CompensatoryOffConsumeComponent {
  isDisabled: boolean = false;
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  user = [] as any;
  Filter = {
    EmpMasterID: null,
    FromDate: null as any,
    ToDate: null as any,
    ApprovalStatus: 'ALL',
    IsWithdraw: false
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    private compensatoryoff: CompensatoryOffService,
    protected common: CommonService,
    private toast: ToastService,
    private session: SessionService,
    private utility: UtilityService,
    private dateFromat: CustomDateParserFormatter,
    private tooltip: TooltipService,
    private modalService: NgbModal,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.Filter.EmpMasterID = this.user.UserId;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.SelectDate('RegistrationDate', null, null);
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.Filter.IsWithdraw) {
        this.ESS_EmployeeCompOffConsumeWithdrawLoad();
      } else {
        this.ESS_EmployeeCompOffConsumeLoad();
      }
    } else {
      form.submitted = true;
    }
  }

  ESS_EmployeeCompOffConsumeLoad() {
    this.Filter.EmpMasterID = this.user.UserId;
    if (moment(this.dateFromat.format(this.Filter.ToDate), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFromat.format(this.Filter.FromDate), 'DD MMM YYYY'))) {
      this.isDisabled = true;
      this.compensatoryoff.ESS_EmployeeCompOffConsumeLoad({ ESS_EmployeeCompOffConsumeId: 0, EmpMasterID: this.Filter.EmpMasterID, FromDate: this.dateFromat.format(this.Filter.FromDate), ToDate: this.dateFromat.format(this.Filter.ToDate), ApprovalStatus: this.Filter.ApprovalStatus, SelectType: 4 }).subscribe({
        next: (response) => {
          if (response.Table && response.Table.length > 0) {
            this.TableDatas = response.Table;
          } else {
            this.TableDatas = [];
          }
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  ESS_EmployeeCompOffConsumeWithdrawLoad() {
    this.isDisabled = true;
    this.Filter.EmpMasterID = this.user.UserId;
    this.compensatoryoff.ESS_EmployeeCompOffWithdrawLoad({ SelectType: 1, EmpMasterID: this.Filter.EmpMasterID, ESS_EmployeeCompOffConsumeId: 0 }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = response.Table;
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          this.isDisabled = false;
        }
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.FromDate = this.dateFromat.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDate = this.dateFromat.parse(response.Table[0].RegistrationDate);

          this.Filter.FromDate.day = 1;
          this.Filter.FromDate.month = 1;
          // this.Filter.ToDate.day = parseInt(moment(response.Table[0].RegistrationDate).endOf('month').format('D'));
          this.Filter.ToDate.day = 31;
          this.Filter.ToDate.month = 12;
        }
        this.ESS_EmployeeCompOffConsumeLoad();
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Clear() {
    this.TableDatas = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  async SaveEmployeeCompOffDetails(index: any) {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to withdraw?';
    modalRef.result.then(result => {
      if (this.common.PageRight.IsView) {
        if (result) {
          this.isDisabled = true;
          this.compensatoryoff.EmployeeCompOffConsumeSave({ 
            SelectType: 'WITHDRAWN', 
            ESS_EmployeeCompOffConsumeId: this.TableDatas[index]['EmployeeCompOffConsumeId'] 
          }).subscribe({
            next: (response) => {
              if (response.Error_Code == '493') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.ESS_EmployeeCompOffConsumeLoad();
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }
}
